import React from 'react';

const Error = () => <h2>Error</h2>;

export default Error;
